module.exports = __webpack_public_path__ + "static/media/CoreUI-Icons-Linear-Free.1bc37648.ttf";